module.exports = __webpack_public_path__ + "static/img/card-001.0aa14fa.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/card-001.png
// module id = f3c4
// module chunks = 1